module.exports = __webpack_public_path__ + "static/img/target-company.663d914.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/target-company.png
// module id = Qqkf
// module chunks = 1